<template lang="pug">
    p(:class="{'mb': marginBottom, 'ml': marginLeft}", v-if="content")
      b {{ label }}
      span.text(v-if="content") &nbsp {{contentFormatado}}
</template>

<script>
export default {

  props: {
    label: {
      type: String,
      required: true
    },
    content: {
      type: Array
    },
    marginBottom: {
      type: Boolean,
      default: false
    },
    marginLeft: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    contentFormatado () {
      let text = ''
      for (let i = 0; i < this.content.length; i++) {
        if (i < this.content.length - 1) {
          if (typeof this.content[0] !== 'string') {
            return this.content.map(a => a.numero).join(', ')
          } else {
            text = text + this.content[i] + ', '
          }
        } else {
          if (typeof this.content[0] !== 'string') {
            return this.content.map(a => a.numero).join(', ')
          } else {
            text = text + this.content[i]
          }
        }
      }

      return text
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/assets/styles/_variables.scss";

.mb {
  margin-bottom: 2vh;
}

.ml {
  margin-left: 15px;
}

p {
  margin-bottom: 1vh;
  font-size: 14px;
  b {
    color: $font-dark-color;
    span{
      font-weight: normal !important;
    }
  }
}

.text {
  color: $font-dark-color;
}

</style>



// WEBPACK FOOTER //
// src/components/AppDisplayMultiple.vue